// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1KfRw","container":"styles_container__16JgQ","title":"styles_title__2HjGY","wrapper":"styles_wrapper__3FO3R","answer":"styles_answer__3lLEv"};